module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_round__oval_vector.9ce5ff45.svg";